(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/information.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/information.js');
'use strict';

const {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const {
  URL
} = svs.selfExclusion.Constants;
const {
  accordion
} = svs.selfExclusion;
const {
  useState
} = React;
const Button = svs.ui.ReactButton;
const Information = () => {
  const [expanded, setExpanded] = useState(false);
  const handleChange = item => isExpanded => {
    setExpanded(isExpanded ? item : '');
  };
  return React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2",
    id: "readMore"
  }, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Information"), React.createElement(Accordion, {
    customer: "sport"
  }, accordion.map(item => React.createElement(AccordionItem, {
    isExpanded: expanded === accordion[item.id],
    key: item.id,
    onChange: handleChange(accordion[item.id])
  }, React.createElement(AccordionSummary, null, React.createElement("h3", null, item.title)), React.createElement(AccordionDetails, null, React.createElement("p", null, item.content))))), React.createElement(Button, {
    block: true,
    className: "margin-xs-top-3 margin-xs-bottom-1",
    href: URL.CUSTOMER_SERVICE_HOME,
    inverted: true,
    size: 300,
    target: "_blank"
  }, "Kontakta kundservice"));
};
svs.selfExclusion.components.Information = Information;

 })(window);